import { render, staticRenderFns } from "./ZCierreInicio.vue?vue&type=template&id=060a3f14"
import script from "./ZCierreInicio.vue?vue&type=script&lang=js"
export * from "./ZCierreInicio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports